import React from 'react';
import { FormattedMessage } from 'react-intl';
import { HelpButton } from '../../../atoms/help-button';
import { SliderBox } from '../../../molecules/slider-box';
import { ParentPaper } from '../../../atoms/parent-paper';
import { useSelector } from '../../../store/utils';

export const SettingsSpotOverflowPrice = () => {
  const maxOverflow = useSelector((s) => s.variables.PV_OVERFLOW_MAX_VALUE);

  return (
    <ParentPaper>
      <SliderBox
        title={
          <>
            <FormattedMessage
              id="settings.spot.price_offset"
              defaultMessage="Cena pro zákaz přetoků"
            />
            <HelpButton
              variant="dialog"
              title={
                <FormattedMessage
                  id="settings.spot.price_offset"
                  defaultMessage="Cena pro zákaz přetoků"
                />
              }
              content={
                <FormattedMessage
                  id="settings.spot.price_offset.help"
                  defaultMessage="Doporučujeme nastavit minimálně ve výši provize/poplatku obchodníkovi za prodej přetoků do sítě."
                />
              }
            />
          </>
        }
        variableId="SP_PRICE_OFFSET_OVERFLOW"
        subtitle={
          <FormattedMessage
            id="settings.spot.price_offset.subtitle"
            defaultMessage="Minimální cena spotu, pod kterou se zakazují přetoky. Hodnota je porovnávána s denním trhem bez distribuční sazby."
          />
        }
        opts={{
          style: 'currency',
          maximumFractionDigits: 2,
          minimumFractionDigits: 2,
        }}
        min={{ CZK: -10, EUR: -0.5 }}
        max={{ CZK: 10, EUR: 0.5 }}
        step={{ CZK: 0.01, EUR: 0.001 }}
      />
      <SliderBox
        title={
          <>
            <FormattedMessage
              id="settings.spot.overflow_offset"
              defaultMessage="Maximální přetok při zákazu přetoků"
            />
            <HelpButton
              variant="dialog"
              title={
                <FormattedMessage
                  id="settings.spot.overflow_offset"
                  defaultMessage="Maximální přetok při záporné ceně"
                />
              }
              content={
                <FormattedMessage
                  id="settings.spot.overflow_offset.help"
                  defaultMessage="Hodnota udává přetok do distribuční sítě při záporné ceně. Tuto funkci doporučujeme využívat v případě energetické komunity."
                />
              }
            />
          </>
        }
        variableId="PV_UTILITY_STOP_OFFSET"
        subtitle={
          <FormattedMessage
            id="settings.spot.overflow_offset.subtitle"
            defaultMessage="Hodnotu není možné nastavit vyšší než maximální přetok"
          />
        }
        opts={{
          style: 'unit',
          unit: 'kilowatt',
          maximumFractionDigits: 1,
          minimumFractionDigits: 1,
        }}
        min={0}
        max={maxOverflow}
        step={0.1}
      />
    </ParentPaper>
  );
};
